var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _vm.opened
    ? _c("div", { staticClass: "modal-mask" }, [
        _c("div", { staticClass: "modal-wrapper" }, [
          _c(
            "div",
            { staticClass: "modal-dialog modal-xl modal-dialog-scrollable" },
            [
              _c("div", { staticClass: "modal-content" }, [
                _c("div", { staticClass: "modal-header" }, [
                  _c("h5", { staticClass: "modal-title" }, [
                    _vm._v(
                      "Attribute dependencies: " + _vm._s(_vm.vm.attributeName)
                    ),
                  ]),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "close",
                      attrs: { type: "button" },
                      on: { click: _vm.close },
                    },
                    [_vm._v("×")]
                  ),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "modal-body" }, [
                  !_vm.rm
                    ? _c("h4", [
                        _c("i", { staticClass: "fa fa-spinner fa-spin" }),
                        _vm._v(" Checking dependencies..."),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.rm
                    ? _c("div", [
                        _c(
                          "div",
                          {
                            staticClass: "alert alert-warning text-dark",
                            attrs: { role: "alert" },
                          },
                          [
                            _c("p", [
                              _vm._v("The attribute '"),
                              _c("strong", [_vm._v(_vm._s(_vm.rm.Name))]),
                              _vm._v("' is used in "),
                              _c("strong", [_vm._v(_vm._s(_vm.rm.Count))]),
                              _vm._v(" places."),
                            ]),
                          ]
                        ),
                        _vm._v(" "),
                        _vm.rm.Forms.length > 0
                          ? _c("div", { staticClass: "card mt-3" }, [
                              _c("div", { staticClass: "card-header" }, [
                                _vm._v(
                                  "\n                                Forms (" +
                                    _vm._s(_vm.rm.Forms.length) +
                                    ")\n                            "
                                ),
                              ]),
                              _vm._v(" "),
                              _c(
                                "ul",
                                { staticClass: "list-group list-group-flush" },
                                _vm._l(_vm.rm.Forms, function (f) {
                                  return _c(
                                    "li",
                                    {
                                      key: f.Id,
                                      staticClass: "list-group-item",
                                    },
                                    [
                                      _c(
                                        "a",
                                        {
                                          directives: [
                                            {
                                              name: "sanitizedHref",
                                              rawName: "v-sanitizedHref",
                                              value: _vm.url_EditFormPage(f),
                                              expression: "url_EditFormPage(f)",
                                            },
                                          ],
                                          staticClass: "text-primary",
                                        },
                                        [_vm._v(_vm._s(f.Name))]
                                      ),
                                    ]
                                  )
                                }),
                                0
                              ),
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.rm.Reports.length > 0
                          ? _c("div", { staticClass: "card mt-3" }, [
                              _c("div", { staticClass: "card-header" }, [
                                _vm._v(
                                  "\n                                Reports (" +
                                    _vm._s(_vm.rm.Reports.length) +
                                    ")\n                            "
                                ),
                              ]),
                              _vm._v(" "),
                              _c(
                                "ul",
                                { staticClass: "list-group list-group-flush" },
                                _vm._l(_vm.rm.Reports, function (r) {
                                  return _c(
                                    "li",
                                    {
                                      key: r.Id,
                                      staticClass: "list-group-item",
                                    },
                                    [
                                      _c(
                                        "a",
                                        {
                                          directives: [
                                            {
                                              name: "sanitizedHref",
                                              rawName: "v-sanitizedHref",
                                              value: _vm.url_ReportViewPage(r),
                                              expression:
                                                "url_ReportViewPage(r)",
                                            },
                                          ],
                                          staticClass: "text-primary",
                                          attrs: { target: "_blank" },
                                        },
                                        [_vm._v(_vm._s(r.Name))]
                                      ),
                                    ]
                                  )
                                }),
                                0
                              ),
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.rm.Criteria.length > 0
                          ? _c("div", { staticClass: "card mt-3" }, [
                              _c("div", { staticClass: "card-header" }, [
                                _vm._v(
                                  "\n                                Criteria (" +
                                    _vm._s(_vm.rm.Criteria.length) +
                                    ")\n                            "
                                ),
                              ]),
                              _vm._v(" "),
                              _c(
                                "ul",
                                { staticClass: "list-group list-group-flush" },
                                _vm._l(_vm.rm.Criteria, function (c) {
                                  return _c(
                                    "li",
                                    {
                                      key: c.Id,
                                      staticClass: "list-group-item",
                                    },
                                    [
                                      _c(
                                        "a",
                                        {
                                          directives: [
                                            {
                                              name: "sanitizedHref",
                                              rawName: "v-sanitizedHref",
                                              value:
                                                _vm.url_MeasurementsPage(c),
                                              expression:
                                                "url_MeasurementsPage(c)",
                                            },
                                          ],
                                          staticClass: "text-primary",
                                          attrs: { target: "_blank" },
                                        },
                                        [_vm._v(_vm._s(c.Name))]
                                      ),
                                      _c("br"),
                                      _vm._v(" "),
                                      _c(
                                        "small",
                                        { staticClass: "text-muted" },
                                        [_vm._v(_vm._s(c.Path))]
                                      ),
                                    ]
                                  )
                                }),
                                0
                              ),
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.rm.Lists.length > 0
                          ? _c("div", { staticClass: "card mt-3" }, [
                              _c("div", { staticClass: "card-header" }, [
                                _vm._v(
                                  "\n                                Lists (" +
                                    _vm._s(_vm.rm.Lists.length) +
                                    ")\n                            "
                                ),
                              ]),
                              _vm._v(" "),
                              _c(
                                "ul",
                                { staticClass: "list-group list-group-flush" },
                                _vm._l(_vm.rm.Lists, function (l) {
                                  return _c(
                                    "li",
                                    {
                                      key: l.Id,
                                      staticClass: "list-group-item",
                                    },
                                    [_c("span", [_vm._v(_vm._s(l.Name))])]
                                  )
                                }),
                                0
                              ),
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.rm.CalcAttributes.length > 0
                          ? _c("div", { staticClass: "card mt-3" }, [
                              _c("div", { staticClass: "card-header" }, [
                                _vm._v(
                                  "\n                                Calculated attributes (" +
                                    _vm._s(_vm.rm.CalcAttributes.length) +
                                    ")\n                            "
                                ),
                              ]),
                              _vm._v(" "),
                              _c(
                                "ul",
                                { staticClass: "list-group list-group-flush" },
                                _vm._l(_vm.rm.CalcAttributes, function (attr) {
                                  return _c(
                                    "li",
                                    {
                                      key: attr.Id,
                                      staticClass: "list-group-item",
                                    },
                                    [_c("span", [_vm._v(_vm._s(attr.Name))])]
                                  )
                                }),
                                0
                              ),
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.rm.Notifications.length > 0
                          ? _c("div", { staticClass: "card mt-3" }, [
                              _c("div", { staticClass: "card-header" }, [
                                _vm._v(
                                  "\n                                Notifications (" +
                                    _vm._s(_vm.rm.Notifications.length) +
                                    ")\n                            "
                                ),
                              ]),
                              _vm._v(" "),
                              _c(
                                "ul",
                                { staticClass: "list-group list-group-flush" },
                                _vm._l(_vm.rm.Notifications, function (n) {
                                  return _c(
                                    "li",
                                    {
                                      key: n.Id,
                                      staticClass: "list-group-item",
                                    },
                                    [_c("span", [_vm._v(_vm._s(n.Name))])]
                                  )
                                }),
                                0
                              ),
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.rm.ScoringSurveys.length > 0
                          ? _c("div", { staticClass: "card mt-3" }, [
                              _c("div", { staticClass: "card-header" }, [
                                _vm._v(
                                  "\n                                Scoring (" +
                                    _vm._s(_vm.rm.ScoringSurveys.length) +
                                    ")\n                            "
                                ),
                              ]),
                              _vm._v(" "),
                              _c(
                                "ul",
                                { staticClass: "list-group list-group-flush" },
                                _vm._l(_vm.rm.ScoringSurveys, function (s) {
                                  return _c(
                                    "li",
                                    {
                                      key: s.Id,
                                      staticClass: "list-group-item",
                                    },
                                    [_c("span", [_vm._v(_vm._s(s.Name))])]
                                  )
                                }),
                                0
                              ),
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.rm.EstimationsSurveys.length > 0
                          ? _c("div", { staticClass: "card mt-3" }, [
                              _c("div", { staticClass: "card-header" }, [
                                _vm._v(
                                  "\n                                Assessments (" +
                                    _vm._s(_vm.rm.EstimationsSurveys.length) +
                                    ")\n                            "
                                ),
                              ]),
                              _vm._v(" "),
                              _c(
                                "ul",
                                { staticClass: "list-group list-group-flush" },
                                _vm._l(_vm.rm.EstimationsSurveys, function (s) {
                                  return _c(
                                    "li",
                                    {
                                      key: s.Id,
                                      staticClass: "list-group-item",
                                    },
                                    [_c("span", [_vm._v(_vm._s(s.Name))])]
                                  )
                                }),
                                0
                              ),
                            ])
                          : _vm._e(),
                      ])
                    : _vm._e(),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "modal-footer" }, [
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-outline-secondary",
                      attrs: { type: "button" },
                      on: { click: _vm.close },
                    },
                    [_vm._v("Close")]
                  ),
                ]),
              ]),
            ]
          ),
        ]),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }